// Image Custom Parallax
window.addEventListener('scroll', () => {
    const parallaxImages = document.querySelectorAll('.parallax-img');
    parallaxImages.forEach(img => {
        const speed = parseFloat(img.getAttribute('data-speed')) || 0.1;
        const rect = img.parentElement.getBoundingClientRect();
        const centerOffset = (window.innerHeight / 2) - (rect.top + rect.height / 2);
        const moveY = centerOffset * speed;
        // Clamp moveY to prevent images from drifting out of their frames
        const clampedMoveY = Math.max(-50, Math.min(50, moveY));
        img.style.transform = `scale(1.2) translateY(${-clampedMoveY}px)`;
    });
});
